import { LitElement, html, svg } from 'lit';

export class IconPlay32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Sirkel med en trekant som peker til høyre</title><circle cx="16" cy="16" r="14.667" stroke="currentColor" stroke-width="1.5"></circle><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 22.667V9.333L22.667 16 12 22.667Z"></path></svg>`; }
}
if (!customElements.get('f-icon-play32', IconPlay32)) {
  customElements.define('f-icon-play32', IconPlay32);
}